<template>
    <div>
        <main-header v-if="showHeader"></main-header>
        <main>
            <slot name="body"></slot>
        </main>
        <main-footer v-if="showFooter"></main-footer>
    </div>
</template>

<script>
    import Header from '@/layout/Header'
    import Footer from '@/layout/Footer'

    export default {
        props: {
            showHeader: {default: true},
            showFooter: {default: true}
        },
        components: {
            'main-header': Header,
            'main-footer': Footer,
        },
    }

</script>

<style lang="scss">
    main {
        min-height: 100vh;
    }
</style>


// WEBPACK FOOTER //
// src/layout/Main.vue